package api.traak.toFirestore

import kotlinx.serialization.Serializable

@Serializable
data class UpdateBexioAuthUserData(
    val teamId: String,
    val userId: String,
)
